interface DateTimeProps {
  dateTimeInfo: {
    day?: string;
    time?: string;
    date?: string;
    query?: string;
  };
  selectedDateTime?: string;
  onSelectDate: (schedule: { option: string }) => void;
}

export const DateTime = ({
  dateTimeInfo,
  selectedDateTime,
  onSelectDate,
}: DateTimeProps) => {
  const { date, day, time = "", query = "" } = dateTimeInfo;

  const option = query ? { option: query } : { option: time };

  const formattTime = (scheduleTime: string) => {
    const toConvertTime = new Date(scheduleTime);
    const hours = String(toConvertTime.getHours()).padStart(2, "0");
    const minutes = String(toConvertTime.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  return (
    <div
      className={`card card-dates ${
        (query && selectedDateTime === query) ||
        (time && selectedDateTime === time)
          ? "_selected"
          : ""
      } `}
      onClick={() => onSelectDate(option)}
      onKeyDown={() => onSelectDate(option)}
      role="button"
      tabIndex={0}
    >
      {day && <div className="day">{day}</div>}
      {date && <div className="date">{date}</div>}
      {time && <div className="date">{formattTime(time)}</div>}
    </div>
  );
};
